module.exports = __webpack_public_path__ + "static/media/financeHead2.0f66c40f.jpg";